import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=6ba839b5&scoped=true&"
import script from "./SupportList.vue?vue&type=script&lang=js&"
export * from "./SupportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba839b5",
  null
  
)

export default component.exports